import { FC, ReactNode } from 'react';
import { FunnelIcon as SolidIcon } from '@heroicons/react/20/solid';
import { FunnelIcon as OutlineIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';

import Text from '@/components/ui/custom/dataDisplay/Text';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import Badge from '@/components/ui/custom/dataDisplay/Badge';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

type FilterHeaderProps = {
  label: string;
  notifications?: number;
  className?: ClassNameComponent;
  icon?: ReactNode;
};

const FilterHeader: FC<FilterHeaderProps> = (props: FilterHeaderProps) => {
  const { label, notifications = 0, className, icon } = props;

  const Icon = notifications > 0 ? SolidIcon : OutlineIcon;

  return (
    <Badge count={notifications} position="-top-1 -right-1" color="info">
      <legend className="flex gap-1 overflow-hidden cursor-pointer items-center">
        <Text
          text={label}
          className={twMerge(
            'text-base-content truncate text-14 lg:text-16',
            className?.label,
          )}
        />
        <ConditionalRenderer
          condition={icon}
          fallback={<Icon className="w-4 text-primary" />}
        >
          {icon}
        </ConditionalRenderer>
      </legend>
    </Badge>
  );
};

export default FilterHeader;
